export class global {
    urlOrigin:string;
    hostName:string;

    constructor(){
        this.getDomainName();
     }

    getDomainName()
    {
        this.urlOrigin=document.location.origin;
        this.hostName=document.location.hostname;
    }

    getApiUrl()
    {
        switch(this.hostName)
        {
            case "localhost":            
                return "http://localhost:64379";
            case "127.0.0.1":
                return "http://localhost:64379";
            default:
                return this.urlOrigin+"/api";
        }
    }
}
